import { useEffect, type ReactNode } from 'react'
import type { SponsorBootstrap } from '@/lib/contract'

/* Spec PWA-001 — FR-033: aplica a identidade visual do tenant (cores, textura, titulo, theme-color) vinda do bootstrap. */
export function BrandProvider({ bootstrap, children }: { bootstrap: SponsorBootstrap; children: ReactNode }) {
    useEffect(() => {
        const root = document.documentElement.style
        const { branding } = bootstrap
        root.setProperty('--brand-primary', branding.themeColor)
        root.setProperty('--brand-accent', branding.accentColor)
        root.setProperty('--brand-background', branding.backgroundColor)
        root.setProperty('--brand-pattern', branding.patternUrl ? `url("${encodeURI(branding.patternUrl)}")` : 'none')
        document.title = bootstrap.appName
        document.querySelector('meta[name="theme-color"]')?.setAttribute('content', branding.themeColor)
    }, [bootstrap])

    return <>{children}</>
}
